import { jsxs as l, jsx as a, Fragment as u } from "react/jsx-runtime";
import { isOrHandleAsExternalUrl as N } from "../../../helpers/link-helper.js";
import { Heading as m } from "../heading/heading.js";
import h from "../link-wrapper/link-wrapper.js";
import { LinkFake as b } from "../link/link.js";
import r from "./card.module.less.js";
import { useTranslation as v } from "react-i18next";
import { SecondaryButtonLink as g } from "../button/button.js";
const y = ({ children: t, link: e, ariaLabel: o, isOutline: n, isProductCard: s }) => /* @__PURE__ */ a(
  h,
  {
    ariaLabel: o,
    className: [r.wrapper, n ? r.outline : "", s ? r.productCard : ""].join(" "),
    url: e ? e.url : void 0,
    target: N(e?.url, e?.target) ? "_blank" : "_self",
    onPreNavigate: e?.onPreNavigate,
    children: t
  }
), j = ({ title: t, subtitle: e, image: o, loading: n = "lazy", badge: s = void 0, link: i }) => /* @__PURE__ */ l("div", { className: r.productWrapper, children: [
  /* @__PURE__ */ l("div", { className: r.productTextWrapper, children: [
    /* @__PURE__ */ a(m, { semanticType: "h3", visualType: "h4", className: [r.productCardTitle, "mb-sm"].join(" "), children: t }),
    /* @__PURE__ */ a("p", { className: [r.productCardSubtitle, "body-base", "mb-md"].join(" "), children: e })
  ] }),
  /* @__PURE__ */ a("div", { className: [r.productButtonWrapper, "mb-md"].join(" "), children: /* @__PURE__ */ a(
    g,
    {
      onPreNavigate: i?.onPreNavigate,
      className: r.link,
      label: i?.title,
      url: i?.url,
      iconRight: "ui-icon-arrow-right"
    }
  ) }),
  /* @__PURE__ */ l("div", { className: r.productImageWrapper, children: [
    s === "member" && /* @__PURE__ */ a("div", { className: r.memberBadge }),
    s === "new" && /* @__PURE__ */ a("div", { className: r.newBadge }),
    /* @__PURE__ */ a("img", { className: r.image, src: o?.url, alt: o?.alt, loading: n })
  ] })
] }), P = ({ label: t }) => /* @__PURE__ */ l("div", { className: r.linkWrapper, children: [
  /* @__PURE__ */ a(b.Primary, { className: r.link, label: t }),
  /* @__PURE__ */ a("span", { className: [r.linkIcon, "ui-icon-arrow-right"].join(" ") })
] }), C = ({ image: t, loading: e = "lazy" }) => /* @__PURE__ */ a("div", { className: [r.imageWrapper, "mb-md"].join(" "), children: /* @__PURE__ */ a("img", { className: r.image, src: t?.url, alt: t?.alt, loading: e }) }), f = ({ date: t, category: e, title: o, semanticHeadingType: n = "h3", text: s, link: i }) => {
  const { t: d } = v(), c = i && i.url ? i.title ? i.title : d("READ_MORE") : void 0, p = !!c;
  return /* @__PURE__ */ l(u, { children: [
    /* @__PURE__ */ l("div", { className: [r.textWrapper, p ? "mb-md" : ""].join(" "), children: [
      (t || e) && /* @__PURE__ */ l("div", { className: r.categoryDateWrapper, children: [
        t && /* @__PURE__ */ a("p", { className: [r.date, "eyebrow"].join(" "), children: t }),
        e && /* @__PURE__ */ a("p", { className: [r.category, "eyebrow"].join(" "), children: e })
      ] }),
      o && /* @__PURE__ */ a(m, { semanticType: n, visualType: "h5", className: [r.title, "mb-xs"].join(" "), children: o }),
      s && /* @__PURE__ */ a("p", { className: [r.text, "body-base mb-0"].join(" "), children: s })
    ] }),
    c && /* @__PURE__ */ a(P, { label: c })
  ] });
}, W = ({ date: t, category: e, title: o, text: n, link: s, isOutline: i, image: d, imageLoading: c }) => /* @__PURE__ */ l(y, { link: s, isOutline: i, children: [
  d && /* @__PURE__ */ a(C, { image: d, loading: c }),
  /* @__PURE__ */ a(f, { date: t, category: e, title: o, text: n, link: s })
] }), x = ({ title: t, subtitle: e, image: o, loading: n, badge: s, link: i }) => /* @__PURE__ */ a(j, { title: t, subtitle: e, image: o, loading: n, badge: s, link: i }), I = {
  Standard: W,
  Product: x
};
export {
  I as Card
};
